import { z } from 'zod'

export const companySchema = z.object({
  tradeName: z.string().min(1, 'Nome fantasia obrigatório').max(100),
  legalName: z.string().min(1, 'Razão social obrigatória').max(100),
  cnpj: z.string().regex(/^\d{14}$/, 'CNPJ deve ter 14 dígitos'),
  stateRegistration: z.string().max(20).optional(),
  phone: z.string().regex(/^\d{10,11}$/, 'Telefone inválido').optional().or(z.literal('')),
  email: z.email('Email inválido').optional().or(z.literal('')),
  contactPerson: z.string().max(100).optional(),
  zipCode: z.string().regex(/^\d{8}$/, 'CEP inválido').optional().or(z.literal('')),
  street: z.string().max(150).optional(),
  number: z.string().max(10).optional(),
  complement: z.string().max(50).optional(),
  neighborhood: z.string().max(100).optional(),
  city: z.string().max(100).optional(),
  state: z.string().length(2, 'UF deve ter 2 caracteres').optional().or(z.literal('')),
})

export type CompanyFormData = z.infer<typeof companySchema>
